import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

const PortalELearning: React.FC<SvgIconProps> = props => {
	return (
		<SvgIcon {...props}>
			<path fill="none" d="M0 0h24v24H0z" />
			<path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
		</SvgIcon>
	);
};

export default PortalELearning;



// WEBPACK FOOTER //
// ./src/icons/PortalELearning.tsx